import React from "react";
import { Table, Card, Button, Popconfirm, Tag, Space, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const EVENT_TYPE_MAP = {
    SCHEDULED: { label: "定检维护", color: "blue" },
    ROUTINE: { label: "例行维护", color: "green" },
    AD_HOC: { label: "临时维护", color: "orange" },
};

const PLANNING_STATUS_MAP = {
    CONFIRMED: { label: "已确认", color: "green" },
    PENDING: { label: "计划待定", color: "gold" },
};

/**
 * 定检维护事件列表组件
 */
const MaintenanceEventList = ({ 
    dataSource = [], 
    loading = false, 
    onEdit, 
    onDelete 
}) => {
    const columns = [
        {
            title: "飞机",
            dataIndex: "aircraft_registration",
            key: "aircraft_registration",
            width: 100,
            render: (text) => (
                <span style={{ fontWeight: 600, color: "#1890ff" }}>{text}</span>
            ),
        },
        {
            title: "状态",
            dataIndex: "planning_status",
            key: "planning_status",
            width: 90,
            render: (status) => {
                const info = PLANNING_STATUS_MAP[status] || PLANNING_STATUS_MAP.CONFIRMED;
                return <Tag color={info.color}>{info.label}</Tag>;
            },
        },
        {
            title: "维护区间",
            key: "flight_range",
            width: 220,
            render: (_, record) => {
                if (record.planning_status === "PENDING") {
                    const dateStr = record.expected_start_date
                        ? dayjs(record.expected_start_date).format("YYYY-MM-DD")
                        : "未设定";
                    return (
                        <span style={{ color: "#999" }}>
                            预计: {dateStr}
                        </span>
                    );
                }
                return (
                    <div>
                        <div style={{ fontSize: 12 }}>
                            <span style={{ fontWeight: 500 }}>{record.prev_flight_number}</span>
                            <span style={{ color: "#999", marginLeft: 4 }}>
                                {dayjs(record.prev_flight_date).format("MM-DD")}
                            </span>
                            <span style={{ margin: "0 6px", color: "#ccc" }}>→</span>
                            <span style={{ fontWeight: 500 }}>{record.next_flight_number}</span>
                            <span style={{ color: "#999", marginLeft: 4 }}>
                                {dayjs(record.next_flight_date).format("MM-DD")}
                            </span>
                        </div>
                    </div>
                );
            },
        },
        {
            title: "类型",
            dataIndex: "event_type",
            key: "event_type",
            width: 100,
            render: (type) => {
                const typeInfo = EVENT_TYPE_MAP[type] || { label: type, color: "default" };
                return <Tag color={typeInfo.color}>{typeInfo.label}</Tag>;
            },
        },
        {
            title: "标题",
            dataIndex: "title",
            key: "title",
            width: 150,
            ellipsis: true,
            render: (text) => text || "-",
        },
        {
            title: "更新时间",
            dataIndex: "updated_at",
            key: "updated_at",
            width: 150,
            render: (text) => text ? dayjs(text).format("YYYY-MM-DD HH:mm") : "-",
        },
        {
            title: "操作",
            key: "action",
            width: 100,
            fixed: "right",
            render: (_, record) => (
                <Space size="small">
                    <Tooltip title="编辑">
                        <Button
                            type="link"
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => onEdit?.(record)}
                        />
                    </Tooltip>
                    <Popconfirm
                        title="确认删除"
                        description={`确定要删除 ${record.aircraft_registration} 的维护事件吗？`}
                        onConfirm={() => onDelete?.(record)}
                        okText="确认"
                        cancelText="取消"
                    >
                        <Tooltip title="删除">
                            <Button
                                type="link"
                                size="small"
                                danger
                                icon={<DeleteOutlined />}
                            />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <Card 
            title={`定检维护事件列表 (${dataSource.length}条)`} 
            size="small"
        >
            <Table
                columns={columns}
                dataSource={dataSource}
                rowKey="id"
                loading={loading}
                size="small"
                scroll={{ x: 900 }}
                pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showTotal: (total) => `共 ${total} 条`,
                }}
            />
        </Card>
    );
};

export default MaintenanceEventList;
